import { WALL, sprintPaused, sprintRemainingMs, type BuildingProgress, type SprintState } from "@engine";
import { $, formatClock } from "./dom.ts";

/** Bar scale for the resource pills; the amount is always shown as text. */
const GOLD_BAR_SCALE = 50_000;
const CRYSTAL_BAR_SCALE = 4_000;

export function bindHud(): {
  setLevel: (level: number) => void;
  setLoot: (gold: number, crystals: number) => void;
  setKeep: (townHall: BuildingProgress | undefined) => void;
  setWalls: (hp: number) => void;
  setSprint: (sprint: SprintState | null, now: number) => void;
} {
  const level = $("hud-level");
  const gold = $("hud-gold");
  const goldFill = $("hud-gold-fill");
  const crystals = $("hud-crystals");
  const crystalFill = $("hud-crystal-fill");
  const keepFill = $("hud-keep-fill");
  const keepText = $("hud-keep-text");
  const walls = $("hud-walls");
  const wallsFill = $("hud-walls-fill");
  const attackChip = $("attack-chip");

  return {
    setLevel(value) {
      level.textContent = String(value);
    },
    setLoot(goldValue, crystalValue) {
      gold.textContent = goldValue.toLocaleString("en-GB");
      crystals.textContent = crystalValue.toLocaleString("en-GB");
      goldFill.style.width = `${percent(goldValue, GOLD_BAR_SCALE)}%`;
      crystalFill.style.width = `${percent(crystalValue, CRYSTAL_BAR_SCALE)}%`;
    },
    setKeep(townHall) {
      if (!townHall) {
        return;
      }
      const milestones = Number(townHall.value) || 0;
      const next = townHall.nextThreshold;
      keepFill.style.width = `${Math.round(townHall.progressToNext * 100)}%`;
      keepText.textContent =
        typeof next === "number"
          ? `Keep · ${milestones} of ${next} milestones`
          : `Keep · ${milestones} milestones`;
    },
    setWalls(hp) {
      walls.textContent = `Walls ${hp} HP`;
      wallsFill.style.width = `${percent(hp, WALL.maxHp)}%`;
    },
    setSprint(sprint, now) {
      if (!sprint || sprint.completed) {
        attackChip.textContent = "25-min sprint";
        return;
      }
      const left = formatClock(sprintRemainingMs(sprint, now));
      attackChip.textContent = sprintPaused(sprint) ? `Paused ${left}` : `${left} left`;
    },
  };
}

function percent(value: number, scale: number): number {
  return Math.max(0, Math.min(100, Math.round((value / scale) * 100)));
}
